import React from 'react';
import { Skeleton, Title } from '@mantine/core';

import Breadcrumbs from './Breadcrumbs';
import TodaysDate from './TodaysDate';

interface Props {
    title?: string;
    isLoading?: boolean;
    friendlyLabels?: {
        originalLabel?: string;
        friendlyLabel?: string;
    }[];
    rightComponent?: React.ReactNode;
    hasBreadcrumb?: boolean;
    hasDate?: boolean;
}

function DashboardHeader({
    title,
    isLoading,
    rightComponent,
    friendlyLabels,
    hasBreadcrumb = true,
    hasDate = false,
}: Props) {
    return (
        <div className="flex justify-between items-center sticky top-0 z-10 bg-[#f8f9fa] h-24 px-11">
            <div>
                {hasBreadcrumb && (
                    <Breadcrumbs
                        friendlyLabels={friendlyLabels}
                        isLoading={isLoading}
                    />
                )}
                {isLoading ? (
                    <Skeleton
                        className="mt-2"
                        height={44}
                        width={200}
                        radius="xl"
                    />
                ) : (
                    <>
                        {hasDate && <TodaysDate />}
                        <Title order={2} className="mt-2 capitalize">
                            {title}
                        </Title>
                    </>
                )}
            </div>

            {!isLoading && (
                <div className="flex shrink-0 items-center">
                    {rightComponent}
                </div>
            )}
        </div>
    );
}

export default DashboardHeader;
